// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","content":"Footer_content__aJpHx","column":"Footer_column__iAwVm","bottom":"Footer_bottom__7buk6"};